import React from 'react';
import SIcon from './SIcon';
import { faTint } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faTint} fa />;

export default Icon;
